export class Themes {

  public static readonly THEME_DEFAULT = 'default';
  public static readonly THEME_LIGHT = 'light';
  public static readonly THEME_BLUE = 'blue';

}
